export const not = (a: number[], b: number[]) => {
    return a.filter(value => !b.includes(value));
};
export const intersection = (a: number[], b: number[]) => {
    return a.filter(value => b.includes(value));
};
